import {Col, Collapse, Empty, Row, Skeleton} from 'antd';
import React from "react";
import {DeleteOutlined, DeleteTwoTone, EditTwoTone} from "@ant-design/icons";
import styled from "styled-components";
import GridActionIcon from "../../../../components/GridActionIcon";
import EditOutlined from "@ant-design/icons/es/icons/EditOutlined";
import InfoCircleOutlined from "@ant-design/icons/es/icons/InfoCircleOutlined";
import InfoCircleTwoTone from "@ant-design/icons/es/icons/InfoCircleTwoTone";

const {Panel} = Collapse;

const CompanyListContainer = styled.div`
    .company-list {
        margin-top: 10px;
    }
    .company-header {
        justify-content: space-between;
    }
`;

const CompanyList = ({data, loading, primaryColor, onEditClick, onDeleteClick, toggleCompanyDetails, companyDetailsVisible, onLicencesClick}) => {

    return <CompanyListContainer>
        {
            loading ? <Skeleton active/> :
                (data.length ? <Collapse className='company-list' accordion>
                            {
                                data.map((record) => {
                                    const {id, companyName, city, country, zipCode} = record;
                                    return <Panel key={id.toString()} header={<Row className='company-header'>
                                        <Col>{companyName}</Col>
                                        <Col>
                                            <GridActionIcon key="edit" title="Edit"
                                                            icon={<EditTwoTone twoToneColor={primaryColor}/>}
                                                            darkIcon={<EditOutlined/>}
                                                            onClick={() => {
                                                                onEditClick({id})
                                                            }}/>

                                            <GridActionIcon key="delete" title="Delete"
                                                            icon={<DeleteTwoTone twoToneColor={primaryColor}/>}
                                                            darkIcon={<DeleteOutlined/>}
                                                            onClick={() => {
                                                                onDeleteClick({
                                                                    id,
                                                                    companyName
                                                                })
                                                            }}/>

                                            <GridActionIcon key="details" title="Details"
                                                            icon={<InfoCircleTwoTone twoToneColor={primaryColor}/>}
                                                            darkIcon={<InfoCircleOutlined/>}
                                                            onClick={() => {
                                                                toggleCompanyDetails(!companyDetailsVisible, record)
                                                            }}/>

                                            {/*<GridActionIcon*/}
                                            {/*key="licences"*/}
                                            {/*title='Licences'*/}
                                            {/*icon={<CopyrightTwoTone twoToneColor={primaryColor}/>}*/}
                                            {/*darkIcon={<DatabaseOutlined/>}*/}
                                            {/*onClick={() => {*/}
                                            {/*onLicencesClick({id});*/}
                                            {/*}}/>*/}
                                        </Col>
                                    </Row>}
                                    >
                                        <p>{city} {zipCode}, {country}</p>
                                    </Panel>
                                })
                            }
                        </Collapse> :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                )
        }
    </CompanyListContainer>
};

export default CompanyList;